import React, { useMemo, useState } from "react";
import TableContainer from "../../Components/Common/TableContainer";
import { Col, Row, Card, CardBody } from "reactstrap";
import Spinners from "Components/Common/Spinner";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { useDeleteSupplier, useGetSuppliers } from "hooks/useSuppliers";

import CellActions from "../../Components/CellActions";
import { AppRoutes } from "../../constants";
import { useNavigate } from "react-router-dom";

function Suppliers() {
  document.title = "Papermap | Suppliers";
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [resource, setResource] = useState<any>(null);

  const { data, isLoading } = useGetSuppliers(); // Fetch suppliers data
  const { mutate } = useDeleteSupplier();

  const handleAddSupplierClick = () => {
    navigate(AppRoutes.CREATE_SUPPLIER);
  };

  const onClickDelete = (item: any) => {
    setResource(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (resource) {
      mutate(resource.id);
      setDeleteModal(false);
      setResource(null); // Clear the selected resource
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Supplier ID",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Phone Number",
        accessorKey: "phone",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Email Address",
        accessorKey: "email",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Address",
        accessorKey: "address",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => (
          <CellActions
            data={cellProps.row.original}
            onEdit={`/edit-supplier/${cellProps.row.original.id}`}
            onView={`/supplier-detail/${cellProps.row.original.id}`}
            onDelete={(data) => onClickDelete(data)}
          />
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteConfirm}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Suppliers" breadcrumbItem="View Suppliers" />
          {isLoading ? (
            <Spinners />
          ) : (
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={data || []}
                      isGlobalFilter={true}
                      isAddButton={true}
                      isCustomPageSize={true}
                      handleUserClick={handleAddSupplierClick}
                      isPagination={true}
                      SearchPlaceholder="50 records..."
                      buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addBranch-modal"
                      buttonName="Add New Supplier"
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Suppliers;
